module.exports = __webpack_public_path__ + "img/noInternet.d341469e.svg";